module.exports = __webpack_public_path__ + "static/img/qpGame.f879cb5.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/img/home/hotGame/qpGame.png
// module id = S6Yt
// module chunks = 3